import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ValidationTopErrorMessage from '../portal/controls/validationTopErrorMessage';
import SmtpSettings from './smtpSettings';
import DomainManagerSettings from './domainManager';
import ToastrLevelsEnum from '../../services/enums/toastrLevelsEnum';
import ToastrService from '../../services/ui/toastrService';

@inject('translationsStore', 'smtpSettingsStore', 'oidcStore', 'configurationsStore') @observer
export default class GeneralSettingsForm extends Component {

    componentDidMount() {
        this.props.configurationsStore.updateStore();
    }

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage('');

        const isValid = this.props.smtpSettingsStore.validateSmtpSettingsForm();

        if (isValid === false) {

            const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
            this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage(validationErrorMessage);
            return;
        }

        this.props.smtpSettingsStore.SaveSmtpSettings().then(() => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('SMTP_SETTINGS_UPDATE_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    };

    buildSmtpSettingsRegionIfNeeded() {
        var { isMultitenancyMode, isDefaultTenant } = this.props.configurationsStore;
        return isMultitenancyMode === false|| isDefaultTenant ? <SmtpSettings /> : null;
    }

    buildDomainManagementSettingsRegionIfNeeded() {
        var { isMultitenancyMode } = this.props.configurationsStore;
        return (isMultitenancyMode === false) ? <DomainManagerSettings /> : null;
    }

    render() {
        var smtpComponent = this.buildSmtpSettingsRegionIfNeeded();
        var domainManagementComponent = this.buildDomainManagementSettingsRegionIfNeeded();

        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <ValidationTopErrorMessage errorMessage={this.props.smtpSettingsStore.saveSmtpSettingsErrorMessage} />
                    {smtpComponent}
                    {domainManagementComponent}
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/generalSettings/generalSettingsForm.jsx